// extracted by mini-css-extract-plugin
module.exports = {"container":"TabNavPeriodos_container__2fG6d","opcaoTab":"TabNavPeriodos_opcaoTab__1ZzBD","ativo":"TabNavPeriodos_ativo__2xXvK"};